import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ApartmentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ApartmentSVG;
